<form
  [formGroup]="paymentForm"
  (ngSubmit)="onSubmit()"
  class="pd-30 h100"
  fxLayout="column"
  style="position: relative; background-color: #ffffff"
  fxLayoutAlign="start stretch"
  fxLayoutGap="30px"
>
  <h3 class="rm-margin" fxFlexAlign="center">
    {{ "SELECT_PAYMENT_METHOD" | translate }}
  </h3>

  <mat-radio-group
    formControlName="paymentType"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="20px"
  >
    <mat-radio-button
      *ngFor="let item of filteredPaymentTypes"
      #radioGroup
      [value]="item"
    >
      <div fxLayout="row" fxLayoutAlign="stretch center" fxLayoutGap="10px">
        <img [src]="item.icon" alt="" />
        <span>{{ item.title | translate }}</span>
      </div>


    </mat-radio-button>


  </mat-radio-group>


  <span *ngIf="showVaultRedirectText | async">{{
    "VAULT_REDIRECT_DESC" | translate
  }}</span>

  <div fxFlex></div>

  <app-order-details-total
    *ngIf="
      !checkoutService.createSavingPlanTypes.includes(
        (checkoutService.selectedPaymentRequest | async)?.type
      )
    "
    [shippingPrice]="checkoutService.shippingPrice | async"
    [totalPrice]="checkoutService.totalPrice | async"
    [taxIncludes]="true"
    [showDeliveryPrice]="checkoutService.redirectToPaymentList.includes(type)"
  ></app-order-details-total>

  <button
    mat-flat-button
    class="my-button"
    color="primary"
    type="submit"
    [disabled]="loading"
  >
    {{ "CONTINUE" | translate }}
  </button>
  <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
</form>
